import {
  type BaseUrl,
  createOrgUrl,
  createPersonUrl, deleteOrgUrl,
  deletePersonUrl,
  type OrgUrl,
  type PersonUrl,
  updateOrgUrl,
  updatePersonUrl
} from 'services'

export function isOrgUrl (url: BaseUrl): url is OrgUrl {
  return 'orgId' in url
}

export function isPersonUrl (url: BaseUrl): url is PersonUrl {
  return 'personId' in url
}

export async function createUrl (url: BaseUrl): Promise<number> {
  if (isOrgUrl(url)) {
    return await createOrgUrl(url)
  } else if (isPersonUrl(url)) {
    return await createPersonUrl(url)
  }
  return 0
}

export async function updateUrl (url: BaseUrl): Promise<boolean> {
  if (isOrgUrl(url)) {
    return await updateOrgUrl(url)
  } else if (isPersonUrl(url)) {
    return await updatePersonUrl(url)
  }
  return false
}

export async function deleteUrl (url: BaseUrl): Promise<boolean> {
  if (isOrgUrl(url)) {
    return await deleteOrgUrl(url)
  } else if (isPersonUrl(url)) {
    return await deletePersonUrl(url)
  }
  return false
}
